<template>
    <b-modal :visible="value" title="자동 초기화" size="md" hide-footer @input="$emit('input', $event)" @hide="$emit('input', false)">
        <div class="auto-init-modal-content">
            <p class="modal-description">
                조직 경계와 운영 경계를 선택하면<br />
                필요한 모든 설정이 자동으로 생성됩니다.
            </p>

            <div class="form-group-compact">
                <label>조직 <span class="required">*</span></label>
                <CarbonSelect
                    :value="initializeForm.orgIdx == null ? '' : initializeForm.orgIdx"
                    :options="orgSelectOptions"
                    placeholder="조직 선택"
                    :placeholderDisabled="false"
                    @input="(v) => onFormChange('orgIdx', v === '' ? null : Number(v))"
                />
            </div>

            <div class="form-group-compact">
                <label>조직 경계 <span class="required">*</span></label>
                <CarbonSelect
                    :value="initializeForm.orgBoundaryIdx == null ? '' : initializeForm.orgBoundaryIdx"
                    :options="orgBoundarySelectOptions"
                    placeholder="조직 경계 선택"
                    :placeholderDisabled="false"
                    :disabled="!initializeForm.orgIdx"
                    @input="(v) => onFormChange('orgBoundaryIdx', v === '' ? null : Number(v))"
                />
            </div>

            <div class="form-group-compact">
                <label>운영 경계 <span class="required">*</span></label>
                <CarbonSelect
                    :value="initializeForm.operBoundaryIdx == null ? '' : initializeForm.operBoundaryIdx"
                    :options="operBoundarySelectOptions"
                    placeholder="운영 경계 선택"
                    :placeholderDisabled="false"
                    :disabled="!initializeForm.orgIdx"
                    @input="(v) => onFormChange('operBoundaryIdx', v === '' ? null : Number(v))"
                />
            </div>
        </div>

        <div class="modal-footer-compact">
            <CarbonButton @click="$emit('input', false)">취소</CarbonButton>
            <CarbonButton :disabled="!canInitialize" @click="$emit('preview')">미리보기</CarbonButton>
            <CarbonButton
                variant="primary"
                :disabled="!canInitialize || loading"
                :loading="loading"
                @click="$emit('execute')"
            >
                실행
            </CarbonButton>
        </div>
    </b-modal>
</template>

<script>
import CarbonButton from "../../common/CarbonButton.vue";
import CarbonSelect from "../../common/CarbonSelect.vue";

export default {
    name: "ActivityConfigAutoInitModal",
    components: { CarbonButton, CarbonSelect },
    props: {
        value: { type: Boolean, default: false },
        initializeForm: {
            type: Object,
            default: () => ({ orgIdx: null, orgBoundaryIdx: null, operBoundaryIdx: null }),
        },
        organizations: { type: Array, default: () => [] },
        filteredOrgBoundaries: { type: Array, default: () => [] },
        filteredOperBoundaries: { type: Array, default: () => [] },
        canInitialize: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    computed: {
        orgSelectOptions() {
            return this.organizations.map((o) => ({ value: o.orgIdx, text: o.orgName }));
        },
        orgBoundarySelectOptions() {
            return this.filteredOrgBoundaries.map((b) => ({
                value: b.orgBoundaryIdx,
                text: b.orgBoundaryName,
            }));
        },
        operBoundarySelectOptions() {
            return this.filteredOperBoundaries.map((b) => ({
                value: b.operBoundaryIdx,
                text: b.operBoundaryName,
            }));
        },
    },
    methods: {
        onFormChange(field, value) {
            const next = { ...this.initializeForm, [field]: value };
            if (field === "orgIdx") {
                next.orgBoundaryIdx = null;
                next.operBoundaryIdx = null;
            }
            this.$emit("update:initializeForm", next);
            if (field === "orgIdx") this.$emit("org-change", value);
        },
    },
};
</script>

<style scoped>
.auto-init-modal-content {
    padding: 8px 0;
}

.modal-description {
    font-size: 13px;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 24px;
    text-align: center;
}

.form-group-compact {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 12px;
}

.form-group-compact label {
    font-size: 12px;
    font-weight: 500;
    color: #475569;
}

.form-group-compact .required {
    color: #dc2626;
}

.modal-footer-compact {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 0 0;
}
</style>
